module.exports = __webpack_public_path__ + "static/media/winners_v.b19fe200.webp";